import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { BranchActionTypes, BranchActions } from "../../../actionTypes/master/branchActionTypes";
import {
  createBranchApi,
  editBranchDataByIdApi,
  getBranchDataByIdApi,
  getBranchListApi,
} from "../../requests/master/branchRequests";
import { getBranchList, setBranchDataById, setBranchList, setBranchListPageCount } from "../../../actions/master/branchAction";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* createBranchHandler(action: BranchActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createBranchApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getBranchListHandler(action: BranchActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getBranchListApi, action.payload);

    if (data.status) {
      yield put(setBranchList(data?.data?.rows));
      yield put(setBranchListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getBranchDataByIdHandler(action: BranchActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getBranchDataByIdApi, action.payload);
    if (data.status) {
      yield put(setBranchDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editBranchDataByIdHandler(action: BranchActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editBranchDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getBranchList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// branch sagas
export default function* branchSaga() {
  yield takeLatest(BranchActions.CREATE_BRANCH, createBranchHandler);
  yield takeLatest(BranchActions.GET_BRANCH_LIST, getBranchListHandler);
  yield takeLatest(BranchActions.GET_BRANCH_DATA_BY_ID, getBranchDataByIdHandler);
  yield takeLatest(BranchActions.EDIT_BRANCH_DATA_BY_ID, editBranchDataByIdHandler);
}
